// extracted by mini-css-extract-plugin
export var fileUpload = "_gn-1";
export var modalButton = "_gn-0";